import { gql } from "@apollo/client";

export const UPDATE_USER = gql`
  mutation Mutation($data: UserUpdateInput!, $where: UserWhereUniqueInput!) {
    updateUser(data: $data, where: $where) {
      id
    }
  }
`;
